module.exports = "https://www.gc-qa.gnp.com.mx/271364c65ed854ab8f301f3511af900c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-conductor-vida.svg
// module id = 8121
// module chunks = 0